import { render, staticRenderFns } from "./TrainingDemandCourses.vue?vue&type=template&id=0a20d4a2&scoped=true"
import script from "./TrainingDemandCourses.vue?vue&type=script&lang=js"
export * from "./TrainingDemandCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20d4a2",
  null
  
)

export default component.exports